import React from 'react';
import ContactScreen from './components/contact';

function Contact() {
  return <ContactScreen />;
}

export default Contact;
